<script>
// import Gltf from '../snippets/Gltf'

export default {

  // components: {
  //   Gltf
  // }

}
</script>

<template>
  <a-text
    geometry="primitive:plane"
    material="color: #ece600;"
    font="exo2bold"
    value="AFV"
    align="center"
    color="#fff"
  />
  <!-- <gltf
    src="/models/russian-soldier/scene.gltf"
    :scale="0.0006"
    position="0 -0.9 0"
  /> -->
</template>
